import { render, staticRenderFns } from "./SignalwireCallLogs.vue?vue&type=template&id=0e00e700&"
import script from "./SignalwireCallLogs.vue?vue&type=script&lang=js&"
export * from "./SignalwireCallLogs.vue?vue&type=script&lang=js&"
import style0 from "./SignalwireCallLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports